// Generated by Melange

import * as Buhta_cabinet__Receipt from "./Receipt.js";
import * as Buhta_cabinet__Shift from "./Shift.js";
import * as JsxRuntime from "react/jsx-runtime";

function KkmLog(Props) {
  let onClose = Props.onClose;
  let onMaximize = Props.onMaximize;
  let maximizeLog = Props.maximizeLog;
  let objectId = Props.objectId;
  let objectType = Props.objectType;
  let orgId = Props.orgId;
  let kkm = Props.kkm;
  switch (objectType) {
    case "kkm_receipt" :
      return JsxRuntime.jsx(Buhta_cabinet__Receipt.make, {
        onMaximize: onMaximize,
        maximizeReceipt: maximizeLog,
        kkm: kkm,
        orgId: orgId,
        id: objectId,
        onClose: onClose
      });
    case "kkm_report" :
      return JsxRuntime.jsx(Buhta_cabinet__Shift.make, {
        kkm: kkm,
        maximizeShift: maximizeLog,
        onMaximize: onMaximize,
        orgId: orgId,
        id: objectId,
        onClose: onClose
      });
    default:
      return null;
  }
}

const make = KkmLog;

export {
  make,
}
/* Buhta_cabinet__Receipt Not a pure module */
